module.exports = "/dist/6ef7418ccdfdc86cf92327030ea5eed9.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-700italic.eot
// module id = 19
// module chunks = 0